import { render, staticRenderFns } from "./user_wt.vue?vue&type=template&id=38f4f7f3&scoped=true"
import script from "./user_wt.vue?vue&type=script&lang=js"
export * from "./user_wt.vue?vue&type=script&lang=js"
import style0 from "./user_wt.vue?vue&type=style&index=0&id=38f4f7f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4f7f3",
  null
  
)

export default component.exports